<template>
    <div>
        <h5 class="header-text">Premedication (複選)</h5>
        <v-switch 
            :label="hasText + '使用止痙攣藥物'"
            v-model="data.antispasmodicHave"
            @change="selectUseOrNot($event)"
            hide-details
        ></v-switch>
        <!-- if not use -->
        <br/>
        <h5 class="header-text">原因：</h5>
        <div v-if="!data.antispasmodicHave">
            <template v-for="item in getNoUseReasons">
                <v-checkbox
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                    v-model="reasonSelected"
                    @change="selectNotUse(item.value)"
                    hide-details
                ></v-checkbox>
            </template>
            <v-layout class="others">
                <v-checkbox
                    label="其他"
                    v-model="othersSelected"
                    hide-details
                ></v-checkbox>
                <v-text-field
                    :value="data.antispasmodicOther"
                    @change="selectOther($event)"
                    hide-details
                ></v-text-field>
            </v-layout>
        </div>
        <!-- if use -->
        <div v-else>
            <template v-for="item in getUseReasons">
                <v-checkbox
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                    v-model="selected"
                    @change="selectUse(item.value)"
                    hide-details
                ></v-checkbox>
            </template>
            <v-layout class="others">
                <v-checkbox
                    label="其他"
                    v-model="othersSelected"
                    hide-details
                ></v-checkbox>
                <v-text-field
                    :value="data.antispasmodicOther"
                    @change="selectOther($event)"
                    hide-details
                ></v-text-field>
            </v-layout>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'AntispasmodicInput',

    props: {
        data: {
            type: Object,
            required: true,
        },
    },

    data () {
        return {
            hasText: '無',
            selected: this.data.antispasmodicIDs,
            reasonSelected: this.data.antispasmodicReason,
            othersSelected: false
        }
    },

    computed: {
        ...mapGetters('examinations', [
            'getAntispasmodicList'
        ]),
        getUseReasons () {
            return this.getAntispasmodicList.map(item => {
                return {
                    text: item.antispasmodic, 
                    value: item.id,
                }
            })
        },
        getNoUseReasons() {
            return this.$store.getters['examinations/getNoUseAntipasmodicReasonList']
        }
    },
    methods: {
        selectOther(value) {
            this.$emit('change', { field: 'antispasmodicOther', event: value })
            this.othersSelected = (value && value.length > 0)
        },
        selectNotUse() {
            this.$emit('change', { field: 'antispasmodicReason', event: this.reasonSelected.join(",") })
        },
        selectUse() {
            this.$emit('change', { field: 'antispasmodicID', event: this.selected.join(",") })
        },
        selectUseOrNot(value) {
            this.hasText = value ? '有': '無'
            this.$emit('change', { field: 'antispasmodicHave', event: value })
        }
    },
    mounted() {
        if (this.data.antispasmodicHave == null) {
            this.selectUseOrNot(false)
        } else {
            this.hasText = this.data.antispasmodicHave ?  '有': '無'
        }
        this.othersSelected = (this.data.antispasmodicOther && this.data.antispasmodicOther.length > 0)
    }
}
</script>